var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6 col-lg-4 mb-4"},[_c('md-card',{class:_vm.management ? 'no-cursor' : '',attrs:{"md-with-hover":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }